
<div id="page" class="col-lg-12">
  <div style="text-align:center; margin-top: 60px;">
    <h3><u><b><i>PLAN DE CUENTAS CONTABLES</i></b></u></h3>
  </div>
  <div style="text-align:center;">
    <br>
    <br>
    <button (click)="getRepo()" type="button" class="btn btn-success">
        DESCARGAR EN FORMATO EXCEL
    </button>
  </div>
  <hr>
</div>